
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12774',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12774",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.487",
  "data-fetching-client": "static-1.9799",
  "foundations-components": "static-1.8212",
  "foundations-components-legacy": "static-1.1237",
  "foundations-theming": "static-1.4574",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.84",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8161",
  "hub-http-shared-msw-handlers": "static-1.10306",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11611",
  "I18n": "static-7.1643",
  "jasmine-runner": "static-1.6596",
  "marketplace-storefront-base": "static-1.12837",
  "quartz": "static-1.7216",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16827",
  "reactive-variable-buffer-atom": "static-1.2996",
  "reporting-testing-lib": "static-1.10047",
  "reselect": "static-3.7",
  "settings-ui-lib": "static-1.12661",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7393",
  "ui-addon-i18n": "static-1.11288",
  "ui-addon-react-router-dom": "static-1.9675",
  "unified-auth": "static-1.660",
  "unified-auth-core-lib": "static-1.942",
  "usage-tracker": "static-1.7492",
  "usage-tracker-core": "static-1.7342",
  "customer-data-property-utils": "static-1.8234",
  "hub-http": "static-1.6361",
  "integrations-lib": "static-1.16588",
  "marketplace-ui-common": "static-1.20225",
  "property-management-iframe": "static-1.13626",
  "quartz-config": "static-1.994",
  "quartz-core": "static-1.6435",
  "quartz-routing": "static-1.646",
  "quick-fetch": "static-1.4024",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4796",
  "ts-schema": "static-1.4188",
  "ui-universal-auth": "static-1.9146",
  "UIComponents": "static-3.8557",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3507",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3493",
  "quartz-webpack": "static-1.3440",
  "bend-plugin-quartz-routing": "static-1.294",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4481",
  "floating-ui": "static-1.59",
  "foundations-assets": "static-1.5013",
  "foundations-theming-specialty": "static-1.2290",
  "framer-motion": "static-1.74",
  "hs-story-utils": "static-1.9563",
  "react-aria": "static-1.68",
  "react-create-root-preference": "static-1.41",
  "react-select-plus": "static-1.107",
  "react-utils": "static-2.5447",
  "react-virtualized": "static-2.101",
  "StyleGuideUI": "static-3.490",
  "tanstack-table": "static-1.57",
  "trellis-assets": "static-1.2226",
  "ui-fonts": "static-1.873",
  "ui-images": "static-2.1193",
  "bend-plugin-foundations-theming": "static-1.3057",
  "foundations-theming-base": "static-1.3559",
  "stylex": "static-1.36",
  "HeadJS": "static-2.775",
  "hs-test-utils-bend-plugin": "static-1.3272",
  "msw": "static-1.39",
  "testing-library": "static-1.154",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.224",
  "moment-timezone": "static-5.85",
  "jasmine": "static-4.4464",
  "ai-components-ui-library": "static-1.9297",
  "ai-rendering-library": "static-1.10677",
  "chirp-fetch": "static-1.2027",
  "connections-embed-lib": "static-1.1259",
  "copilot-toolkit": "static-1.11488",
  "feedback-loader": "static-1.29558",
  "laboratory-lib": "static-3.7292",
  "marketplace-embed": "static-1.22507",
  "marketplace-ui-details": "static-1.10120",
  "marketplace-ui-reviews": "static-1.20180",
  "marketplace-ui-tracking": "static-1.14395",
  "sanitize-text": "static-1.8286",
  "ui-addon-video-player": "static-1.8845",
  "usage-tracker-multi": "static-1.5906",
  "usage-tracker-session-replay": "static-1.5178",
  "wootric-nps": "static-1.7088",
  "quartz-head": "static-1.881",
  "web-vitals": "static-1.8",
  "apollo-link-hub-http": "static-2.4791",
  "immer": "static-1.33",
  "immerable": "static-1.4290",
  "highcharts": "static-8.106",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2586",
  "reporting-data": "static-1.68114",
  "cssUtils": "static-1.835",
  "flux-actions": "static-1.350",
  "HubStyle": "static-2.11918",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10347",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10502",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7482",
  "icons": "static-2.658",
  "marketplace-ui-apps-core": "static-1.18757",
  "storybook-react": "static-1.35",
  "trellis-story-utils": "static-1.4649",
  "foundations-components-test-utils": "static-1.5695",
  "quartz-i18n": "static-1.891",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.79",
  "ads-unified-auth-lib": "static-1.527",
  "google-sheets-integration-lib": "static-1.641",
  "microsoft-drive-integration-lib": "static-1.804",
  "surveymonkey-integration-lib": "static-1.98",
  "slack-ui-library": "static-1.10538",
  "fsm": "static-1.3870",
  "customer-data-objects": "static-1.7818",
  "property-translator": "static-1.5536",
  "hs-locale-management": "static-1.188",
  "frontend-preferences-client": "static-1.8066",
  "hs-promise-utils": "static-1.5733",
  "hubspot-apollo-client": "static-1.5017",
  "integrations-error-boundary-lib": "static-1.14003",
  "integrations-tracking-lib": "static-1.5747",
  "native-integrations-shared-strings": "static-1.7920",
  "sanitize": "static-1.4616",
  "superstore": "static-1.4899",
  "ui-shepherd-react": "static-3.10397",
  "ai-settings-ui-library": "static-1.8112",
  "hub-http-janus": "static-1.850",
  "hubspotter-http": "static-1.4757",
  "immutable-less": "static-1.4791",
  "marketplace-ui-client-types": "static-1.17632",
  "nav-meta": "static-1.29974",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18184",
  "inbound-db-properties-service-client": "static-1.3953",
  "property-management-common": "static-1.5914",
  "ui-addon-iframeable": "static-1.9208",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.549",
  "module-federation": "static-1.28",
  "quartz-auth": "static-1.891",
  "quartz-test": "static-1.891",
  "quartz-tracking": "static-1.595",
  "trellis-components": "static-1.2245",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.206",
  "bender-build-tools": "static-1.3301",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21980",
  "ContentUtils": "static-1.68768",
  "customer-data-objects-ui-components": "static-1.13169",
  "sassPrefix": "static-1.158",
  "avatar-components": "static-1.2638",
  "breeze-engine-core": "static-1.473",
  "breeze-onboarding-components": "static-1.312",
  "customer-data-filters-ui": "static-1.40290",
  "customer-data-reference-ui-components": "static-1.13315",
  "embedded-academy-lib": "static-1.14802",
  "ExportDialog": "static-6.10519",
  "highlight.js": "static-1.81",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41651",
  "reporting-snowflake": "static-1.56732",
  "reporting-ui-components": "static-2.65385",
  "reporting-visualizations": "static-1.60190",
  "trellis-theming": "static-1.1083",
  "ui-addon-teams": "static-1.21732",
  "integrations-reconnect-lib": "static-1.232",
  "magpie-lib": "static-1.5644",
  "navigation-components": "static-1.18337",
  "breeze-engine-lib": "static-1.1195",
  "magpie-types": "static-1.5104",
  "simple-logging-lib": "static-1.3188",
  "ai-studio-lib": "static-1.12018",
  "app-governance-lib": "static-1.1984",
  "developer-experience-shared-components": "static-1.10669",
  "hubspot-prosemirror": "static-1.18626",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8150",
  "ui-product-approvals": "static-1.28689",
  "ui-tool-access": "static-1.10291",
  "usage-based-billing-components-lib": "static-1.9519",
  "usage-tracker-anonymous": "static-1.5909",
  "usage-tracker-public": "static-1.7303",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3694",
  "persist-promise": "static-1.3841",
  "reference-resolvers": "static-1.8315",
  "ui-extensibility-client-types": "static-1.4064",
  "hubspot-apollo-cache": "static-1.476",
  "universal-page-editor-lib": "static-1.3151",
  "final-form": "static-1.72",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3164",
  "atom": "static-1.5215",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6127",
  "salesImages": "static-1.528",
  "batch-promise": "static-1.1684",
  "crm-component-utils": "static-1.39441",
  "crm-properties-common-lib": "static-1.6030",
  "customer-data-properties": "static-1.52028",
  "framework-data-schema-resolvers": "static-1.7033",
  "property-value-citations": "static-1.2642",
  "reference-resolvers-lite": "static-1.8236",
  "ui-business-units-lib": "static-1.9209",
  "navigation-messaging": "static-1.7664",
  "hubspotter-http-shared-msw-handlers": "static-1.10304",
  "base-ui": "static-1.16",
  "react-day-picker": "static-1.5",
  "tanstack-virtual": "static-1.32",
  "cms-field-types": "static-1.4954",
  "content-icons-ui": "static-1.2270",
  "customer-data-ui-utilities": "static-1.9964",
  "conversations-skeleton-state": "static-1.7387",
  "crm-message-bus": "static-1.43352",
  "customer-data-filters-ui-msw-helpers": "static-1.22725",
  "events-data-lib": "static-1.376",
  "FormUrlGenerator": "static-2.4862",
  "framework-builder-read-service-client": "static-1.4112",
  "framework-data-schema-quick-fetch": "static-1.6938",
  "multi-account-reference-resolvers": "static-1.1121",
  "onboarding-tours": "static-1.16871",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14074",
  "academy-common-lib": "static-1.14262",
  "content-assistance-lib": "static-1.7978",
  "dashboard-lib": "static-1.82064",
  "file-manager-components": "static-1.24034",
  "getting-started-shared-tasks": "static-1.18796",
  "hubspot-prosemirror-plugins": "static-1.18618",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20075",
  "share-with-third-party-component-lib": "static-1.8844",
  "ui-addon-draggable": "static-3.4900",
  "ui-asset-management-lib": "static-1.11218",
  "user-context": "static-1.5248",
  "growth-payments-core": "static-1.25782",
  "reporting-plugins": "static-1.10542",
  "reporting-reports": "static-1.67792",
  "idb-keyval": "static-1.46",
  "reactive-lib": "static-1.865",
  "nest": "static-1.373",
  "ably": "static-2.2",
  "codemirror": "static-5.97",
  "react-codemirror": "static-1.10767",
  "framework-listing-lib": "static-2.29078",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31017",
  "apps-service-types": "static-1.3940",
  "oauth-service-types": "static-1.4394",
  "content-media-capture": "static-1.4944",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8560",
  "payment-link-components": "static-1.23869",
  "ui-addon-emoji-picker": "static-1.10024",
  "video-components-external": "static-1.11741",
  "video-data-lib": "static-1.35399",
  "react-dnd-compat": "static-1.4754",
  "ui-product-approvals-common": "static-1.584",
  "onboarding-scopes": "static-1.6600",
  "onboarding-tours-client": "static-1.5085",
  "platform-infra-nav-components": "static-1.7780",
  "subscription-experience-data-types": "static-1.15093",
  "crm-record-cards-service-types": "static-1.3692",
  "location-customization-utils-lib": "static-1.9652",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6130",
  "signup-constants": "static-1.19208",
  "signup-ui-url-generator": "static-2.8198",
  "card-properties-lib": "static-1.44607",
  "commerce-subscription-lib": "static-1.37473",
  "crm-actions": "static-1.6480",
  "crm-cards-sdk": "static-1.44003",
  "customer-data-properties-shared-msw-handlers": "static-1.9633",
  "customer-data-tracking": "static-1.7026",
  "hs-resources": "static-1.318",
  "pulse": "static-1.744",
  "calling-global-api": "static-1.64963",
  "calling-internal-common": "static-1.31452",
  "calling-lifecycle-internal": "static-1.66345",
  "calling-lifecycle-messages": "static-1.58639",
  "commerce-products-lib": "static-1.10076",
  "conditional-properties-service-client": "static-1.3904",
  "crm-links": "static-1.6448",
  "crm-pipelines-api-client-types": "static-1.4244",
  "external-options-client-types": "static-1.4233",
  "formula-editor": "static-1.14512",
  "google-libphonenumber": "static-1.40",
  "inbounddb-objects-service-types": "static-1.4324",
  "meetings-icalendar-utils-lib": "static-1.773",
  "multi-currency-client-types": "static-1.3798",
  "object-builder-ui-client": "static-1.49225",
  "pipeline-validation-client-types": "static-1.4073",
  "smart-property-lib": "static-1.7979",
  "tiered-pricing": "static-1.1591",
  "topics-actions-lib": "static-1.233",
  "ui-addon-form-validation": "static-1.11131",
  "zustand": "static-1.74",
  "fdsr-migration-layer": "static-1.152",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1245",
  "growth-data-modal": "static-1.5662",
  "growth-onboarding-confetti": "static-1.3205",
  "growth-onboarding-next-action-utils": "static-1.2312",
  "onboarding-tours-utils": "static-1.937",
  "ui-shepherd-tracker": "static-1.7778",
  "academy-service-client": "static-1.3823",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39533",
  "FileManagerLib": "static-1.39674",
  "SafeStorage": "static-1.4540",
  "video-embed": "static-1.36233",
  "ui-coaching-tips": "static-1.28942",
  "redux-actions": "static-3.7",
  "EmailSignatureEditor": "static-1.24676",
  "viral-links-lib": "static-1.7210",
  "data-token-picker": "static-1.16655",
  "react-flip-move": "static-1.73",
  "nested-table": "static-1.379",
  "timezone-utils": "static-2.5383",
  "seat-types-lib": "static-1.311",
  "getting-started-shared-tasks-store": "static-1.17914",
  "ui-addon-opt": "static-4.8501",
  "campaign-roi-lib": "static-1.9527",
  "ui-addon-calendars": "static-2.5462",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25731",
  "framework-data-table": "static-2.12229",
  "marketing-platform-lib": "static-1.7006",
  "nudge-client-utils": "static-1.2882",
  "nudge-custom-ui-functions": "static-1.1276",
  "switchboard-lib": "static-1.365",
  "app-users-service-client": "static-1.5753",
  "app-users-service-types": "static-1.5161",
  "mini-checkout-client": "static-1.27147",
  "onboarding-utils": "static-1.5497",
  "permissions-shared-i18n-strings-fe": "static-1.2062",
  "ui-coaching-tips-shared-config": "static-1.28927",
  "content-media-composition-data-lib": "static-1.12748",
  "fix-webm-duration": "static-1.25",
  "notification-sounds": "static-1.4565",
  "commerce-tours-lib": "static-1.6362",
  "growth-onboarding-reliability": "static-1.5221",
  "sales-checkout-service-client": "static-1.3723",
  "content-media-compositions": "static-2.16755",
  "media-bridge-lib": "static-1.19172",
  "edison-service-client-types": "static-1.528",
  "crm_data": "static-4.92397",
  "customer-data-sidebar": "static-2.46392",
  "enrichment-properties-lib": "static-1.17097",
  "ui-addon-draggable-compat": "static-2.4400",
  "universal-record-utils-lib": "static-1.1318",
  "commerce-billing-lib": "static-1.19543",
  "commerce-shared-components-lib": "static-1.18887",
  "commerce-tools-ui-lib": "static-1.10739",
  "crm-fe-perf": "static-1.23041",
  "event-emitter": "static-1.1089",
  "bend-plugin-pulse": "static-1.247",
  "fast-json-patch": "static-1.65",
  "calling-error-reporting": "static-1.31459",
  "shared-worker-versioning": "static-1.11175",
  "calling-usage-tracker": "static-1.6682",
  "voice-sms-access-library": "static-1.1501",
  "commerce-permissions": "static-1.914",
  "products-iframe-lib": "static-1.8311",
  "products-ui-components-shared-msw-handlers": "static-1.10688",
  "bark-lib": "static-1.16604",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.429",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10389",
  "policy-lib": "static-1.6925",
  "react-tinymce": "static-1.55609",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10452",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54735",
  "tinymce-plugins": "static-1.57849",
  "tinymce-themes": "static-1.56705",
  "onboarding-data-sync-lib": "static-1.2211",
  "growth-onboarding-next-action-components": "static-1.2340",
  "user-context-client": "static-1.4718",
  "audio-components": "static-1.6134",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37185",
  "html-to-image": "static-1.56",
  "urlinator": "static-1.4674",
  "video-components": "static-1.13743",
  "outpost": "static-1.4309",
  "growth-onboarding-feedback-components": "static-1.6718",
  "draft-convert": "static-2.75",
  "draft-extend": "static-3.77",
  "draft-js": "static-5.80",
  "draft-plugins": "static-2.21923",
  "sales-email-signature-service-client": "static-1.3989",
  "ts-utils-lib": "static-1.313",
  "crm-export-dialog": "static-1.6424",
  "crm-index-associations-lib": "static-1.6581",
  "crm-view-components": "static-1.691",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7472",
  "nudge-custom-function-registry": "static-1.2639",
  "nudge-renderer-utils": "static-1.2958",
  "whisper-core-api": "static-1.6927",
  "InboxConnectUtils": "static-4.15187",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5858",
  "settings-content-modals": "static-1.46472",
  "js-cookie": "static-1.18",
  "crm_universal": "static-1.22256",
  "customer-data-email": "static-1.18287",
  "card-payment-highlight-lib": "static-1.37563",
  "card-subscription-highlight-lib": "static-1.39896",
  "commerce-contract-lib": "static-1.12715",
  "invoices-highlight-card-lib": "static-1.55170",
  "orders-highlight-card-lib": "static-1.21845",
  "products-highlight-card-lib": "static-1.18359",
  "quotes-highlight-card-lib": "static-1.72475",
  "crm-source-interpretation-lib": "static-1.5471",
  "crm-object-search-query-utilities": "static-1.9889",
  "utility-belt": "static-1.2671",
  "payments-enrollment-embed-lib": "static-1.23340",
  "stripe-embedded-components": "static-1.7757",
  "customer-data-rte": "static-1.33351",
  "cv-backend-services": "static-1.1575",
  "growth-onboarding-empty-states": "static-1.6005",
  "payments-post-enroll-local-storage-lib": "static-1.5246",
  "qrcode-generator": "static-1.71",
  "quotes-client-types": "static-1.38565",
  "trials-service-types": "static-1.4023",
  "calling-orchestration-schema": "static-1.36278",
  "sales-views-client-types": "static-1.4397",
  "react-reducer-toolkit": "static-1.15973",
  "hub-http-contrib": "static-1.3183",
  "interframe": "static-3.4898",
  "tinymce-data": "static-1.40820",
  "ui-addon-sales-email": "static-1.5350",
  "layout-dnd-components": "static-1.12720",
  "layout-dnd-utils": "static-1.11695",
  "ui-brand-identity-lib": "static-1.15789",
  "NamespacedHubStyle": "static-2.9160",
  "meetings-connect-utils-lib": "static-1.7745",
  "social-insights-client-types": "static-1.22414",
  "crm-index-visualization-core": "static-1.4316",
  "checkout-sdk": "static-3.23990",
  "company-details-components": "static-1.6337",
  "payment-method-components": "static-1.7005",
  "pricing-pages-ui-components": "static-1.14821",
  "quote-checkout-service-types": "static-1.3604",
  "upgrade-catalog-service-types": "static-1.3659",
  "access-control-lib": "static-1.10577",
  "EmailComponents": "static-1.55158",
  "EmailData": "static-1.53835",
  "redux-less": "static-2.9622",
  "sequences-lib": "static-1.8279",
  "ui-gdpr-components": "static-1.10492",
  "products-ui-components": "static-1.40594",
  "accounting-integrations-ui-components": "static-1.7292",
  "invoices-ui-lib": "static-1.55186",
  "commerce-products-api": "static-1.2497",
  "invoices-iframe-lib": "static-1.57244",
  "quotes-modal-lib": "static-1.103153",
  "quotes-ui-lib": "static-1.81196",
  "stripe-connect-js": "static-1.71",
  "draft-content-plugins": "static-1.28616",
  "ContentData": "static-1.68843",
  "layout-data-lib": "static-1.10020",
  "checkout-service-types": "static-1.3903",
  "hub-http-rxjs": "static-1.816",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4076",
  "billing-payments-client-types": "static-1.4129",
  "react-performance-metrics-lib": "static-1.697",
  "pricing-pages-api": "static-1.14686",
  "ContentComponents": "static-2.71724",
  "marketing-contacts-lib": "static-1.10504",
  "marketing-email-service-types": "static-1.2007",
  "messaging-editing-lib": "static-1.46680",
  "messaging-usage-based-billing-components-lib": "static-1.1542",
  "automation-ui-source-apps": "static-1.19280",
  "automation-ui-types": "static-1.20198",
  "messaging-types-lib": "static-1.46417",
  "onboarding-settings-client": "static-1.4645",
  "sequences-client-types-lib": "static-1.8136",
  "commerce-tax-lib": "static-1.676",
  "price-books-api": "static-1.1305",
  "price-books-components": "static-1.1363",
  "property-description-translator": "static-1.3980",
  "ramp-editor": "static-1.525",
  "commerce-analytics-service-client": "static-1.3711",
  "totals-ui-components": "static-1.23969",
  "SalesContentIndexUI": "static-3.9442",
  "advanced-menus-core": "static-1.15364",
  "advanced-menus-lib": "static-1.12272",
  "ui-memberships-settings-lib": "static-1.34417",
  "segments-query-core": "static-1.1560",
  "automation-ui-ubb": "static-1.6114",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7478",
  "data-token-views": "static-1.16636",
  "forms-utils-lib": "static-1.12848",
  "payments-embed-points-lib": "static-1.13323",
  "simple-menus-core": "static-1.15363",
  "simple-menus-lib": "static-1.16880",
  "videoconference-integration-components": "static-1.7034",
  "mc-hard-limits-client-types": "static-1.38",
  "marketing-contacts-client": "static-1.7649",
  "automation-applications-service-types": "static-1.3598",
  "automation-platform-service-types": "static-1.2632",
  "ContentEditorUI": "static-2.77483",
  "short-messages-app-service-client": "static-1.4062",
  "web-interactives-components": "static-1.14005",
  "web-interactives-data": "static-1.14006",
  "messaging-shared-utils-lib": "static-1.991",
  "messaging-user-info-utils-lib": "static-1.1161",
  "email-portal-health-service-types": "static-1.1117",
  "line-items-api": "static-1.896",
  "commerce-totals-service-types": "static-1.3924",
  "FireAlarmUi": "static-1.4615",
  "sales-templates-service-types-lib": "static-1.4276",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22134",
  "automation-ui-usage-tracking": "static-1.21597",
  "data-studio-ubb": "static-1.3118",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27337",
  "collaboration-sidebar": "static-1.58258",
  "content-management-data-lib": "static-1.5662",
  "copilot-plugins": "static-1.11461",
  "cta-picker": "static-1.36758",
  "customer-agent-discovery-components-lib": "static-1.3476",
  "editor-components": "static-1.13436",
  "editor-iframe-lib": "static-1.8601",
  "error-messaging-js": "static-1.5334",
  "FormsCommonComponents": "static-1.86189",
  "pictos": "static-7.187",
  "react-transition-group": "static-2.67",
  "redux-request-state": "static-1.10787",
  "SharedLegalStrings": "static-1.1884",
  "smart-content-core": "static-1.42817",
  "smart-content-lib": "static-1.43470",
  "social-composer-lib": "static-1.59653",
  "structured-content-lib": "static-1.25559",
  "theme-previewer-lib": "static-1.53619",
  "tinymce-copilot": "static-1.16803",
  "xray-recommendation-lib": "static-1.8086",
  "automation-ui-routing": "static-1.21555",
  "sql-reporting-client-types": "static-1.5755",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42494",
  "campaigns-utils-lib": "static-1.3334",
  "reporting-enablement": "static-1.23380",
  "chatspot-widget-iframe": "static-1.21971",
  "collaboration-sidebar-common": "static-1.3055",
  "forms-ai-lib": "static-1.4541",
  "codemirror-dlb": "static-1.59042",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6575",
  "report-customization-components": "static-1.13542",
  "data-quality-ui-library": "static-1.13400",
  "reporting-filters": "static-1.665",
  "reporting-insights-lib": "static-1.2147"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12774",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.487",
  "data-fetching-client": "/data-fetching-client/static-1.9799",
  "foundations-components": "/foundations-components/static-1.8212",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1237",
  "foundations-theming": "/foundations-theming/static-1.4574",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.84",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8161",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10306",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11611",
  "I18n": "/I18n/static-7.1643",
  "jasmine-runner": "/jasmine-runner/static-1.6596",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12837",
  "quartz": "/quartz/static-1.7216",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16827",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2996",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10047",
  "reselect": "/reselect/static-3.7",
  "settings-ui-lib": "/settings-ui-lib/static-1.12661",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7393",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11288",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9675",
  "unified-auth": "/unified-auth/static-1.660",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.942",
  "usage-tracker": "/usage-tracker/static-1.7492",
  "usage-tracker-core": "/usage-tracker-core/static-1.7342",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8234",
  "hub-http": "/hub-http/static-1.6361",
  "integrations-lib": "/integrations-lib/static-1.16588",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20225",
  "property-management-iframe": "/property-management-iframe/static-1.13626",
  "quartz-config": "/quartz-config/static-1.994",
  "quartz-core": "/quartz-core/static-1.6435",
  "quartz-routing": "/quartz-routing/static-1.646",
  "quick-fetch": "/quick-fetch/static-1.4024",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4796",
  "ts-schema": "/ts-schema/static-1.4188",
  "ui-universal-auth": "/ui-universal-auth/static-1.9146",
  "UIComponents": "/UIComponents/static-3.8557",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3507",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3493",
  "quartz-webpack": "/quartz-webpack/static-1.3440",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.294",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4481",
  "floating-ui": "/floating-ui/static-1.59",
  "foundations-assets": "/foundations-assets/static-1.5013",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2290",
  "framer-motion": "/framer-motion/static-1.74",
  "hs-story-utils": "/hs-story-utils/static-1.9563",
  "react-aria": "/react-aria/static-1.68",
  "react-create-root-preference": "/react-create-root-preference/static-1.41",
  "react-select-plus": "/react-select-plus/static-1.107",
  "react-utils": "/react-utils/static-2.5447",
  "react-virtualized": "/react-virtualized/static-2.101",
  "StyleGuideUI": "/StyleGuideUI/static-3.490",
  "tanstack-table": "/tanstack-table/static-1.57",
  "trellis-assets": "/trellis-assets/static-1.2226",
  "ui-fonts": "/ui-fonts/static-1.873",
  "ui-images": "/ui-images/static-2.1193",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3057",
  "foundations-theming-base": "/foundations-theming-base/static-1.3559",
  "stylex": "/stylex/static-1.36",
  "HeadJS": "/HeadJS/static-2.775",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3272",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.154",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.224",
  "moment-timezone": "/moment-timezone/static-5.85",
  "jasmine": "/jasmine/static-4.4464",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9297",
  "ai-rendering-library": "/ai-rendering-library/static-1.10677",
  "chirp-fetch": "/chirp-fetch/static-1.2027",
  "connections-embed-lib": "/connections-embed-lib/static-1.1259",
  "copilot-toolkit": "/copilot-toolkit/static-1.11488",
  "feedback-loader": "/feedback-loader/static-1.29558",
  "laboratory-lib": "/laboratory-lib/static-3.7292",
  "marketplace-embed": "/marketplace-embed/static-1.22507",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10120",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20180",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14395",
  "sanitize-text": "/sanitize-text/static-1.8286",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8845",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5906",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5178",
  "wootric-nps": "/wootric-nps/static-1.7088",
  "quartz-head": "/quartz-head/static-1.881",
  "web-vitals": "/web-vitals/static-1.8",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4791",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4290",
  "highcharts": "/highcharts/static-8.106",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2586",
  "reporting-data": "/reporting-data/static-1.68114",
  "cssUtils": "/cssUtils/static-1.835",
  "flux-actions": "/flux-actions/static-1.350",
  "HubStyle": "/HubStyle/static-2.11918",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10347",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10502",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7482",
  "icons": "/icons/static-2.658",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18757",
  "storybook-react": "/storybook-react/static-1.35",
  "trellis-story-utils": "/trellis-story-utils/static-1.4649",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5695",
  "quartz-i18n": "/quartz-i18n/static-1.891",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.79",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.527",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.641",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.804",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.98",
  "slack-ui-library": "/slack-ui-library/static-1.10538",
  "fsm": "/fsm/static-1.3870",
  "customer-data-objects": "/customer-data-objects/static-1.7818",
  "property-translator": "/property-translator/static-1.5536",
  "hs-locale-management": "/hs-locale-management/static-1.188",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8066",
  "hs-promise-utils": "/hs-promise-utils/static-1.5733",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5017",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14003",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5747",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7920",
  "sanitize": "/sanitize/static-1.4616",
  "superstore": "/superstore/static-1.4899",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10397",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8112",
  "hub-http-janus": "/hub-http-janus/static-1.850",
  "hubspotter-http": "/hubspotter-http/static-1.4757",
  "immutable-less": "/immutable-less/static-1.4791",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17632",
  "nav-meta": "/nav-meta/static-1.29974",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18184",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3953",
  "property-management-common": "/property-management-common/static-1.5914",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9208",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.549",
  "module-federation": "/module-federation/static-1.28",
  "quartz-auth": "/quartz-auth/static-1.891",
  "quartz-test": "/quartz-test/static-1.891",
  "quartz-tracking": "/quartz-tracking/static-1.595",
  "trellis-components": "/trellis-components/static-1.2245",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.206",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21980",
  "ContentUtils": "/ContentUtils/static-1.68768",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13169",
  "sassPrefix": "/sassPrefix/static-1.158",
  "avatar-components": "/avatar-components/static-1.2638",
  "breeze-engine-core": "/breeze-engine-core/static-1.473",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.312",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40290",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13315",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14802",
  "ExportDialog": "/ExportDialog/static-6.10519",
  "highlight.js": "/highlight.js/static-1.81",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41651",
  "reporting-snowflake": "/reporting-snowflake/static-1.56732",
  "reporting-ui-components": "/reporting-ui-components/static-2.65385",
  "reporting-visualizations": "/reporting-visualizations/static-1.60190",
  "trellis-theming": "/trellis-theming/static-1.1083",
  "ui-addon-teams": "/ui-addon-teams/static-1.21732",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.232",
  "magpie-lib": "/magpie-lib/static-1.5644",
  "navigation-components": "/navigation-components/static-1.18337",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1195",
  "magpie-types": "/magpie-types/static-1.5104",
  "simple-logging-lib": "/simple-logging-lib/static-1.3188",
  "ai-studio-lib": "/ai-studio-lib/static-1.12018",
  "app-governance-lib": "/app-governance-lib/static-1.1984",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10669",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18626",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8150",
  "ui-product-approvals": "/ui-product-approvals/static-1.28689",
  "ui-tool-access": "/ui-tool-access/static-1.10291",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9519",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5909",
  "usage-tracker-public": "/usage-tracker-public/static-1.7303",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3694",
  "persist-promise": "/persist-promise/static-1.3841",
  "reference-resolvers": "/reference-resolvers/static-1.8315",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4064",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.476",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3151",
  "final-form": "/final-form/static-1.72",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3164",
  "atom": "/atom/static-1.5215",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6127",
  "salesImages": "/salesImages/static-1.528",
  "batch-promise": "/batch-promise/static-1.1684",
  "crm-component-utils": "/crm-component-utils/static-1.39441",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6030",
  "customer-data-properties": "/customer-data-properties/static-1.52028",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7033",
  "property-value-citations": "/property-value-citations/static-1.2642",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8236",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9209",
  "navigation-messaging": "/navigation-messaging/static-1.7664",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10304",
  "base-ui": "/base-ui/static-1.16",
  "react-day-picker": "/react-day-picker/static-1.5",
  "tanstack-virtual": "/tanstack-virtual/static-1.32",
  "cms-field-types": "/cms-field-types/static-1.4954",
  "content-icons-ui": "/content-icons-ui/static-1.2270",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9964",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7387",
  "crm-message-bus": "/crm-message-bus/static-1.43352",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22725",
  "events-data-lib": "/events-data-lib/static-1.376",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4862",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4112",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6938",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1121",
  "onboarding-tours": "/onboarding-tours/static-1.16871",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14074",
  "academy-common-lib": "/academy-common-lib/static-1.14262",
  "content-assistance-lib": "/content-assistance-lib/static-1.7978",
  "dashboard-lib": "/dashboard-lib/static-1.82064",
  "file-manager-components": "/file-manager-components/static-1.24034",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18796",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18618",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20075",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8844",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4900",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11218",
  "user-context": "/user-context/static-1.5248",
  "growth-payments-core": "/growth-payments-core/static-1.25782",
  "reporting-plugins": "/reporting-plugins/static-1.10542",
  "reporting-reports": "/reporting-reports/static-1.67792",
  "idb-keyval": "/idb-keyval/static-1.46",
  "reactive-lib": "/reactive-lib/static-1.865",
  "nest": "/nest/static-1.373",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.97",
  "react-codemirror": "/react-codemirror/static-1.10767",
  "framework-listing-lib": "/framework-listing-lib/static-2.29078",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31017",
  "apps-service-types": "/apps-service-types/static-1.3940",
  "oauth-service-types": "/oauth-service-types/static-1.4394",
  "content-media-capture": "/content-media-capture/static-1.4944",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8560",
  "payment-link-components": "/payment-link-components/static-1.23869",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10024",
  "video-components-external": "/video-components-external/static-1.11741",
  "video-data-lib": "/video-data-lib/static-1.35399",
  "react-dnd-compat": "/react-dnd-compat/static-1.4754",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.584",
  "onboarding-scopes": "/onboarding-scopes/static-1.6600",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5085",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7780",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15093",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3692",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9652",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6130",
  "signup-constants": "/signup-constants/static-1.19208",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8198",
  "card-properties-lib": "/card-properties-lib/static-1.44607",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37473",
  "crm-actions": "/crm-actions/static-1.6480",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44003",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9633",
  "customer-data-tracking": "/customer-data-tracking/static-1.7026",
  "hs-resources": "/hs-resources/static-1.318",
  "pulse": "/pulse/static-1.744",
  "calling-global-api": "/calling-global-api/static-1.64963",
  "calling-internal-common": "/calling-internal-common/static-1.31452",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66345",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58639",
  "commerce-products-lib": "/commerce-products-lib/static-1.10076",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3904",
  "crm-links": "/crm-links/static-1.6448",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4244",
  "external-options-client-types": "/external-options-client-types/static-1.4233",
  "formula-editor": "/formula-editor/static-1.14512",
  "google-libphonenumber": "/google-libphonenumber/static-1.40",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4324",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.773",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3798",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49225",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4073",
  "smart-property-lib": "/smart-property-lib/static-1.7979",
  "tiered-pricing": "/tiered-pricing/static-1.1591",
  "topics-actions-lib": "/topics-actions-lib/static-1.233",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11131",
  "zustand": "/zustand/static-1.74",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.152",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1245",
  "growth-data-modal": "/growth-data-modal/static-1.5662",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3205",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2312",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.937",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7778",
  "academy-service-client": "/academy-service-client/static-1.3823",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39533",
  "FileManagerLib": "/FileManagerLib/static-1.39674",
  "SafeStorage": "/SafeStorage/static-1.4540",
  "video-embed": "/video-embed/static-1.36233",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28942",
  "redux-actions": "/redux-actions/static-3.7",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24676",
  "viral-links-lib": "/viral-links-lib/static-1.7210",
  "data-token-picker": "/data-token-picker/static-1.16655",
  "react-flip-move": "/react-flip-move/static-1.73",
  "nested-table": "/nested-table/static-1.379",
  "timezone-utils": "/timezone-utils/static-2.5383",
  "seat-types-lib": "/seat-types-lib/static-1.311",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17914",
  "ui-addon-opt": "/ui-addon-opt/static-4.8501",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9527",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5462",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25731",
  "framework-data-table": "/framework-data-table/static-2.12229",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7006",
  "nudge-client-utils": "/nudge-client-utils/static-1.2882",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1276",
  "switchboard-lib": "/switchboard-lib/static-1.365",
  "app-users-service-client": "/app-users-service-client/static-1.5753",
  "app-users-service-types": "/app-users-service-types/static-1.5161",
  "mini-checkout-client": "/mini-checkout-client/static-1.27147",
  "onboarding-utils": "/onboarding-utils/static-1.5497",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2062",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28927",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12748",
  "fix-webm-duration": "/fix-webm-duration/static-1.25",
  "notification-sounds": "/notification-sounds/static-1.4565",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6362",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5221",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3723",
  "content-media-compositions": "/content-media-compositions/static-2.16755",
  "media-bridge-lib": "/media-bridge-lib/static-1.19172",
  "edison-service-client-types": "/edison-service-client-types/static-1.528",
  "crm_data": "/crm_data/static-4.92397",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46392",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17097",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4400",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1318",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19543",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18887",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10739",
  "crm-fe-perf": "/crm-fe-perf/static-1.23041",
  "event-emitter": "/event-emitter/static-1.1089",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.247",
  "fast-json-patch": "/fast-json-patch/static-1.65",
  "calling-error-reporting": "/calling-error-reporting/static-1.31459",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11175",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6682",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1501",
  "commerce-permissions": "/commerce-permissions/static-1.914",
  "products-iframe-lib": "/products-iframe-lib/static-1.8311",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10688",
  "bark-lib": "/bark-lib/static-1.16604",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.429",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10389",
  "policy-lib": "/policy-lib/static-1.6925",
  "react-tinymce": "/react-tinymce/static-1.55609",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10452",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54735",
  "tinymce-plugins": "/tinymce-plugins/static-1.57849",
  "tinymce-themes": "/tinymce-themes/static-1.56705",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2211",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2340",
  "user-context-client": "/user-context-client/static-1.4718",
  "audio-components": "/audio-components/static-1.6134",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37185",
  "html-to-image": "/html-to-image/static-1.56",
  "urlinator": "/urlinator/static-1.4674",
  "video-components": "/video-components/static-1.13743",
  "outpost": "/outpost/static-1.4309",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6718",
  "draft-convert": "/draft-convert/static-2.75",
  "draft-extend": "/draft-extend/static-3.77",
  "draft-js": "/draft-js/static-5.80",
  "draft-plugins": "/draft-plugins/static-2.21923",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3989",
  "ts-utils-lib": "/ts-utils-lib/static-1.313",
  "crm-export-dialog": "/crm-export-dialog/static-1.6424",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6581",
  "crm-view-components": "/crm-view-components/static-1.691",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7472",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2639",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2958",
  "whisper-core-api": "/whisper-core-api/static-1.6927",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15187",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5858",
  "settings-content-modals": "/settings-content-modals/static-1.46472",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_universal": "/crm_universal/static-1.22256",
  "customer-data-email": "/customer-data-email/static-1.18287",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37563",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39896",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12715",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55170",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21845",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18359",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72475",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5471",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9889",
  "utility-belt": "/utility-belt/static-1.2671",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23340",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7757",
  "customer-data-rte": "/customer-data-rte/static-1.33351",
  "cv-backend-services": "/cv-backend-services/static-1.1575",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6005",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5246",
  "qrcode-generator": "/qrcode-generator/static-1.71",
  "quotes-client-types": "/quotes-client-types/static-1.38565",
  "trials-service-types": "/trials-service-types/static-1.4023",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36278",
  "sales-views-client-types": "/sales-views-client-types/static-1.4397",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.15973",
  "hub-http-contrib": "/hub-http-contrib/static-1.3183",
  "interframe": "/interframe/static-3.4898",
  "tinymce-data": "/tinymce-data/static-1.40820",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5350",
  "layout-dnd-components": "/layout-dnd-components/static-1.12720",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11695",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15789",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9160",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7745",
  "social-insights-client-types": "/social-insights-client-types/static-1.22414",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4316",
  "checkout-sdk": "/checkout-sdk/static-3.23990",
  "company-details-components": "/company-details-components/static-1.6337",
  "payment-method-components": "/payment-method-components/static-1.7005",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14821",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3604",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3659",
  "access-control-lib": "/access-control-lib/static-1.10577",
  "EmailComponents": "/EmailComponents/static-1.55158",
  "EmailData": "/EmailData/static-1.53835",
  "redux-less": "/redux-less/static-2.9622",
  "sequences-lib": "/sequences-lib/static-1.8279",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10492",
  "products-ui-components": "/products-ui-components/static-1.40594",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7292",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55186",
  "commerce-products-api": "/commerce-products-api/static-1.2497",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57244",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103153",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81196",
  "stripe-connect-js": "/stripe-connect-js/static-1.71",
  "draft-content-plugins": "/draft-content-plugins/static-1.28616",
  "ContentData": "/ContentData/static-1.68843",
  "layout-data-lib": "/layout-data-lib/static-1.10020",
  "checkout-service-types": "/checkout-service-types/static-1.3903",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.816",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4076",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4129",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.697",
  "pricing-pages-api": "/pricing-pages-api/static-1.14686",
  "ContentComponents": "/ContentComponents/static-2.71724",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10504",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2007",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46680",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1542",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19280",
  "automation-ui-types": "/automation-ui-types/static-1.20198",
  "messaging-types-lib": "/messaging-types-lib/static-1.46417",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4645",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8136",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.676",
  "price-books-api": "/price-books-api/static-1.1305",
  "price-books-components": "/price-books-components/static-1.1363",
  "property-description-translator": "/property-description-translator/static-1.3980",
  "ramp-editor": "/ramp-editor/static-1.525",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3711",
  "totals-ui-components": "/totals-ui-components/static-1.23969",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9442",
  "advanced-menus-core": "/advanced-menus-core/static-1.15364",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12272",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34417",
  "segments-query-core": "/segments-query-core/static-1.1560",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6114",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7478",
  "data-token-views": "/data-token-views/static-1.16636",
  "forms-utils-lib": "/forms-utils-lib/static-1.12848",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13323",
  "simple-menus-core": "/simple-menus-core/static-1.15363",
  "simple-menus-lib": "/simple-menus-lib/static-1.16880",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7034",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.38",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7649",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3598",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2632",
  "ContentEditorUI": "/ContentEditorUI/static-2.77483",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4062",
  "web-interactives-components": "/web-interactives-components/static-1.14005",
  "web-interactives-data": "/web-interactives-data/static-1.14006",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.991",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1161",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1117",
  "line-items-api": "/line-items-api/static-1.896",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3924",
  "FireAlarmUi": "/FireAlarmUi/static-1.4615",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4276",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22134",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21597",
  "data-studio-ubb": "/data-studio-ubb/static-1.3118",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27337",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58258",
  "content-management-data-lib": "/content-management-data-lib/static-1.5662",
  "copilot-plugins": "/copilot-plugins/static-1.11461",
  "cta-picker": "/cta-picker/static-1.36758",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3476",
  "editor-components": "/editor-components/static-1.13436",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8601",
  "error-messaging-js": "/error-messaging-js/static-1.5334",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86189",
  "pictos": "/pictos/static-7.187",
  "react-transition-group": "/react-transition-group/static-2.67",
  "redux-request-state": "/redux-request-state/static-1.10787",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1884",
  "smart-content-core": "/smart-content-core/static-1.42817",
  "smart-content-lib": "/smart-content-lib/static-1.43470",
  "social-composer-lib": "/social-composer-lib/static-1.59653",
  "structured-content-lib": "/structured-content-lib/static-1.25559",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53619",
  "tinymce-copilot": "/tinymce-copilot/static-1.16803",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8086",
  "automation-ui-routing": "/automation-ui-routing/static-1.21555",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5755",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42494",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3334",
  "reporting-enablement": "/reporting-enablement/static-1.23380",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21971",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3055",
  "forms-ai-lib": "/forms-ai-lib/static-1.4541",
  "codemirror-dlb": "/codemirror-dlb/static-1.59042",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6575",
  "report-customization-components": "/report-customization-components/static-1.13542",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13400",
  "reporting-filters": "/reporting-filters/static-1.665",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2147"
}
};
